import CourseButton from '../../subcomponents/coursebuttom';
import WhyUnito from './WhyUnito';
import HowItWorks from './HowitWorks';
import Testimonials from './Reviews';
import CallToAction from './Calltoaction';
import React from 'react';


function FrontPage() {
    return(
        <>
        <main className="container mx-auto p-4 flex flex-col items-center text-center">
        <h1 className="text-6xl text-white font-bold mt-12">
          Welcome to{' '}
          <span className="bg-gradient-to-r from-violet-500 to-red-500 text-transparent bg-clip-text">
            Unito
          </span>
        </h1>
        <p className="text-gray-400 mt-4">
        Where Passion Meets Discipline – Track, Practice, and Excel!
        </p>
      </main>
      <div className='mt-36'>
      <div className="flex flex-wrap justify-center mt-8">
        <CourseButton
          title="Dsa Practice"
          description="Learn the basics of programming."
          icon="💻"
          url="/problems"
        />
        <CourseButton className="px-3"
          title="Track Progress"
          description=" Track Your Leetcode Progress Here"
          icon="🤝"
          url="/profile"
        />
        <CourseButton
          title="AI Coach"
          description="Master the art of coding......with AI!"
          icon="💬"
          url="/chat"
        />
        </div>
      </div>
      <WhyUnito />
      <HowItWorks />
      <Testimonials />
      <CallToAction />
        </>
    );
}

export default FrontPage;